import Styled from 'styled-components';
import { WIDGET_ROOT_TAG } from '../../Ids';
import { VIEWPORT_XXS_MAX } from '../../util/mediaQueries';

export const Label = Styled.div`
  font-family: Lato, sans-serif;
  font-weight: bold;
  text-align: center;
  color: ${props => props.theme.buttonTextColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  font-size: 22px;
  @media ${VIEWPORT_XXS_MAX} {
    font-size: 20px;
  }
`;

export const SubLabel = Styled.div`
  padding-top: 8px;
  font-family: Lato, sans-serif;
  color: ${props => props.theme.buttonTextColor};
  text-align: center;
  font-size: 16px;
  @media ${VIEWPORT_XXS_MAX} {
    padding-top: 4px;
    font-size: 14px;
  }
`;

export default Styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  #${WIDGET_ROOT_TAG} &{
    padding: 1em 0;
    font-size: 1em;
    font-weight: 400;
    line-height: 1.25em;
    color: ${props => props.theme.buttonTextColor};
    text-align: center;
    background-color: ${props => props.theme.buttonBackgroundColor};
    border: 1px solid ${props => props.theme.buttonBorderColor};
    border-radius: 0.125em;
    outline: unset;
    cursor: pointer;
    transition:
      box-shadow ${props => props.theme.buttonAnimationDuration} ease-out,
      background-color ${props => props.theme.buttonAnimationDuration} ease-out,
      transform ${props => props.theme.buttonAnimationDuration} ease-out
    ;

    &:hover {
      background-color: ${props => props.theme.buttonBackgroundColorHover};
      border-color: ${props => props.theme.buttonBorderColorHover};
    }

    &:focus {
      border-color: ${props => props.theme.buttonBorderColorFocus};
    }

    &:active {
      background-color: ${props => props.theme.buttonBackgroundColorActive};
    }

    &:disabled {
      color: #95A1AB;
      background-color: ${props => props.theme.buttonBackgroundColorDisabled};
    }
  }
`;
